import InfoAlert from './InfoAlert.vue'

export default InfoAlert